export enum ComplianceRatingColor {
  compliant = '#4FA46F',
  partlyCompliant = '#DDAD42',
  notCompliant = '#B52D2D',
  notRated = '#DEDEDE'
}
